import { Component, HostBinding, Input } from '@angular/core';
import { EAkkyProDocument } from '@core-constants/akky-pro.constants';

@Component({
  selector: 'app-akky-pro-termns-and-conditions',
  templateUrl: './akky-pro-termns-and-conditions.component.html',
  styleUrls: ['./akky-pro-termns-and-conditions.component.css'],
  host: {
    class: 'd-flex aling-items-center justify-content-center'
  }
})
export class AkkyProTermnsAndConditionsComponent
{
  @Input({required: true}) public backgroundColor!: string;
  
  @HostBinding('style.background-color') public get setBackground(): string
  {
    return this.backgroundColor;
  }
  
  @HostBinding('style.min-height') public maxHeight = '554px';
  
  public get termsConditionsPDF(): string
  {
    return EAkkyProDocument.TermsConditions;
  }
}
